export default "__VITE_ASSET__B7QGh4Dw__"